import React, {Component} from 'react';
import sanitizeHtml from 'sanitize-html-react';
import LocResourcesContext, {LocResourcesContextProps} from '../contexts/LocResourcesContext';
import defaultBanner from "../assets/img/banners/reward-shop-icon-700-x-220-int.png";
import biggerDefaultBanner from "../assets/img/banners/reward-shop-icon-700-x-220-int@2x.png";

const imageRoute = require.context("../assets/img/banners/custom-banner", true);
const GLOBAL_PREFIX = "loy-bppo-bannerContainer";

interface BannerProps {
    siteDomain: string;
    view: string;
    defaultTitle: string;
    defaultSubtitle: string;
    bannerName: string;
    showNewSimplifiedBanner: boolean;
}

interface BannerStates {
    siteDomain: string;
    defaultTitle: string;
    defaultSubtitle: string;
    bannerName: string;
    showNewSimplifiedBanner: boolean;
    customBannerNotFound: boolean;
}

export default class Banner extends Component<BannerProps, BannerStates> {

    constructor(props: BannerProps) {
        super(props);

        const {siteDomain, view, defaultTitle, defaultSubtitle, bannerName, showNewSimplifiedBanner} = this.props;

        this.state = {
            siteDomain: siteDomain,
            defaultTitle: defaultTitle,
            defaultSubtitle: defaultSubtitle,
            customBannerNotFound: false,
            bannerName: `${view}-${bannerName}`,
            showNewSimplifiedBanner: showNewSimplifiedBanner

        }

    }

    onFormatLocale (localeKey: string, params: any = undefined): string {
        return (this.context as LocResourcesContextProps).onFormatLocale(localeKey, params);
    }

    getCustomBanner() {
        try {
            return imageRoute(`./${this.state.siteDomain}/${this.state.bannerName}`);
        }
        catch (e) {
            this.setState({customBannerNotFound: true})
        }
    }

    defaultHeader() {
        if (this.state.showNewSimplifiedBanner) {
            return <header className={`${GLOBAL_PREFIX}__title`}>
                <div>{this.onFormatLocale("mzp.overview.bonus-program.view-reward-shop")}</div>
            </header>
        } else {
            return <header className={GLOBAL_PREFIX}>
                <div className={`${GLOBAL_PREFIX}__content`}>
                    <div>{this.onFormatLocale(this.state.defaultTitle)}</div>
                    <p>
                        <span dangerouslySetInnerHTML={{__html: sanitizeHtml(this.onFormatLocale(this.state.defaultSubtitle))}}/>
                    </p>
                </div>
                <div className={`${GLOBAL_PREFIX}__image`}>
                    <img
                        src={defaultBanner}
                        srcSet={defaultBanner + " 1x," + biggerDefaultBanner + " 2x"}/>
                </div>
            </header>
        }
    }

    getHeader() {
        return <header className={GLOBAL_PREFIX}>
            <img id="custom-banner" className={`${GLOBAL_PREFIX}__image`}
                 src={this.getCustomBanner()}/>
        </header>
    }

    render() {
        if (this.state.customBannerNotFound) {
            return this.defaultHeader();
        } else {
            return this.getHeader();
        }
    }
};
Banner.contextType = LocResourcesContext as React.Context<LocResourcesContextProps>;

